import { defineStore } from 'pinia'

export const useFilters = defineStore( 'filters', {
    state: () => ( {
        filters: {}
    } ),


    getters: {
        getComponentFilters: ( state ) => ( componentName ) => {
            return state.filters[ componentName ] || {}
        }
    },

    actions: {
        setFilters( componentName, initial ) {
            if ( !( componentName in this.filters ) )
                this.filters = {
                    ...this.filters,
                    [componentName]: initial
                }
        },

        setState( state ) {
            this.filters = { ...state }
        },

        clear() {
            this.filters = {}
        },

        clearFilters( componentName, initial ) {
            this.filters[ componentName ] = initial
        }
    }
} )
